// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#4155f0","errorColor":"#f25e5e","errorBgColor":"rgba(242,94,94,0.75)","successColor":"#48c980"};